import Component from './apollo'

export default Component
